import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import React from "react";

const Searchbar = ({
  label,
  value,
  setValue,
  width,
  height,
  fontSize,
  searchIconDisabled,
}) => {
  // Prevent Enter from submitting form (or reloading page)
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <TextField
      fullWidth
      label={label}
      autoComplete="off"
      value={value}
      size="small"
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={handleKeyDown}
      sx={{
        height: "100%",
        width,
        "& .MuiInputBase-root": {
          height: "100%",
          fontSize,
        },
        "& .MuiInputLabel-root": {
          fontSize,
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {!searchIconDisabled && (
              <IconButton tabIndex={-1}>
                <GridSearchIcon />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default Searchbar;
